/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable import/prefer-default-export */
import PubSub from 'pubsub-js';
import { isArray } from 'coreutils-js';

const publishStacks = {};

setInterval(() => {
  Object.keys(publishStacks).forEach((topic) => {
    if (isArray(publishStacks[topic]) && publishStacks[topic].length > 0) {
      const value = publishStacks[topic].pop();
      publish(topic, value);
    }
  });
}, 100);

export function publish(topic, value) {
  if (PubSub.publish(topic)) {
    PubSub.publish(topic, value);
  } else {
    if (!isArray(publishStacks[topic])) publishStacks[topic] = [];

    publishStacks[topic].push(value);
  }
}
